import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPartnerOnboardingSignupContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PartnerOnboardingSignupContainer" */
                '@perpay-web/fintech/components/containers/PartnerOnboardingCardSignUpContainer'
            ),
    );
